import utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IDocument {
    id: string;
    key: string;
    originalFilename: string;
    extension: string;
    contentType: string;
    size: number;
    created: Date;
    createdByUserID: string;
}

export class Document implements IDocument {

    constructor(data?: IDocument) {
        if (data) this.update(data);
    }

    update(data: IDocument): void {
        mapData(data, { root: () => this });
    }

    id: string = utils.emptyGuidValue;
    key: string = utils.emptyGuidValue;
    originalFilename: string = "";
    extension: string = "";
    contentType: string = "";
    size: number = 0;
    created: Date = new Date(utils.emptyDateValue);
    createdByUserID: string = utils.emptyGuidValue;
}
